import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-case-listing',
  templateUrl: './case-listing.component.html',
  styleUrls: ['./case-listing.component.css']
})
export class CaseListingComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
